var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 784 569",
    style: {
      enableBackground: "new 0 0 784 569"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BBDBF3;}\n\t.st1{fill:#B6D4FF;}\n\t.st2{fill:#2D628C;}\n\t.st3{fill:#FDAE97;}\n\t.st4{fill:#3F62FE;}\n\t.st5{fill:#558AFF;}\n\t.st6{fill:#E5F0F8;}\n\t.st7{fill:#E89780;}\n\t.st8{fill:#93ACBF;}\n\t.st9{fill:#322A28;}\n\t.st10{fill:none;stroke:#E89780;stroke-width:0.9672;stroke-miterlimit:10;}\n\t.st11{fill:#2C3447;}\n\t.st12{fill:none;stroke:#2C3447;stroke-width:1.2109;stroke-miterlimit:10;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:#403534;}\n\t.st15{fill:none;stroke:#FFFFFF;stroke-width:0.6443;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#558AFF;stroke-width:3.8445;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#586773;stroke-width:1.9222;stroke-miterlimit:10;}\n\t.st18{fill:#A06753;}\n\t.st19{fill:#E7888B;}\n\t.st20{fill:#088CFC;}\n\t.st21{fill:#824C3A;}\n\t.st22{fill:none;stroke:#724638;stroke-width:0.89;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#2C3447;stroke-width:1.3213;stroke-miterlimit:10;}\n\t.st24{fill:#A14C53;}\n\t.st25{fill:none;stroke:#558AFF;stroke-width:4.0402;stroke-miterlimit:10;}\n\t.st26{fill:none;stroke:#FFFFFF;stroke-width:1.5071;stroke-miterlimit:10;}\n\t.st27{fill:none;stroke:#2C3447;stroke-width:1.8298;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.7,514.1L579.7,514.1c2.3,0,4.2-1.9,4.2-4.2v-4.7c0-2.3-1.9-4.2-4.2-4.2l0,0c-2.3,0-4.2,1.9-4.2,4.2v4.7 C575.4,512.3,577.3,514.1,579.7,514.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "602.1,482.3 556.8,501 602.1,493.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.2,
    y: 327.9,
    className: "st0",
    width: 12.5,
    height: 165.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.1,
    y: 482.3,
    className: "st0",
    width: 62.6,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.2,
    y: 325.5,
    className: "st0",
    width: 36.2,
    height: 10.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M710.1,514.1L710.1,514.1c-2.3,0-4.2-1.9-4.2-4.2v-4.7c0-2.3,1.9-4.2,4.2-4.2l0,0c2.3,0,4.2,1.9,4.2,4.2v4.7 C714.3,512.3,712.4,514.1,710.1,514.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "664.7,482.3 710.1,501 664.7,493.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M623.2,178.1c0,0,111.8-5.4,116.1,74.6S664.6,372,595.7,346C500,310,506.9,196.2,623.2,178.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "676.1,280.8 676.3,250 640.2,255.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M451.3,186.6l-8.4-5.6c0,0-10.2-3.7-13.7-5.5c-2-1-7.6-3.1-8.7-3.1c-0.8,0-2.2,1.3-1.9,2 c0.4,0.9,5.2,4.5,7,5.9c1.7,1.4,6.9,5.4,6.9,5.4s-16.6-1.5-22.1-2.3c-3.1-0.5-12.1-2.2-12.6,0c-0.3,1.6,8.7,4.4,11.8,5.4 c2.8,0.9,11.3,3.7,11.3,3.7s-12.2-1.9-16.3-2.6c-3-0.5-11.6-3-12.2-0.6c-0.6,2.4,8.2,4.2,11,5.1c4,1.3,16.1,5.3,16.1,5.3 s-12.9-1.7-17.1-2.3c-2.4-0.3-9.3-2.2-9.7,0.1c-0.4,2.3,6.8,3.3,9.2,3.9c4,1.1,16.1,4.3,16.1,4.3s-9.3-1-12.4-1.3 c-1.3-0.1-5.3-0.4-5.4,0.9c-0.1,1.8,5.2,2.6,7,3l14.5,3.8c1.2,0.3,2.4,0.5,3.6,0.5l22,3.1L451.3,186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M627.9,238.5l-138.3,41.8c-3.8,0.5-7.5,1.5-11.1,3.4c-16.9,8.5-23.7,29-15.2,45.9s29,23.7,45.9,15.2 l155.3-33.4L627.9,238.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M459.7,325.5c-0.2-1.6-0.4-3.2-0.4-4.8c0-18.9,15.3-34.2,34.2-34.2s34.2,15.3,34.2,34.2l-2,152.6h-56.9 L459.7,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M656.6,316.7l-110.9,43.6c-19.6,7.7-41.9-2-49.6-21.6v0c-7.7-19.6,2-41.9,21.6-49.6l110.9-43.6 c19.6-7.7,41.9,2,49.6,21.6l0,0C685.9,286.7,676.2,309,656.6,316.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "604.7,98.3 568.5,114.6 573.5,261.4 676.3,263 691.9,112 641.7,95.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M604.7,77.1V100c0,0,1.4,5,13,5c11.6,0,23.9-7.7,23.9-7.7l-3.6-50.1L604.7,77.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "604.7,96.9 628.5,72.1 604.7,71.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M594.9,31c0,0,0,14.1,0,24v8.2c0,6.5,1.8,16.2,9.2,18.4c7.3,2.2,17.4-0.8,24.4-8.4c7-7.6,22.6-42.1,0.9-54.8 C607.8,5.7,595.4,27.6,594.9,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M561.6,224.6c-2.3,9.6-11.2,16-20.8,15.6l0,0l-96.2-20.4L446,207l2.6-23.5l0.3-2.7l97.8,19.3 C557.5,202.8,564.2,213.8,561.6,224.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M493.5,322.2c0-18.9,15.3-34.2,34.2-34.2c18.9,0,29.2,7.9,33.4,26.7c9.6,43.7,29.6,160.1,29.6,160.1h-59.2 L493.9,327C493.6,325.4,493.5,323.8,493.5,322.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M530.2,236L530.2,236c11.8,5.6,25.9,0.5,31.5-11.3l37-78.1c5.6-11.8,0.5-25.9-11.3-31.5h0 c-11.8-5.6-25.9-0.5-31.5,11.3l-37,78.1C513.4,216.3,518.4,230.4,530.2,236z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M627.2,17.2c0,0-26.2-12.1-32.3-4.1c-6,7.9,4,10.7,4,10.7s-12.5-1.5-12,7c0.5,8.4,31.8-3.1,31.8-3.1 s-10.4,4.7-4.4,8.4c6,3.7,12.9-1.1,12.9-1.1s5.9,3.4,5,19c-1,15.6,8.3,19.1,8.3,19.1s-1.1-23.7,3.5-30 C648.5,36.7,641.8,13.3,627.2,17.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M630.7,57.6c-2.5,4-3.2,6.8-0.1,8.8c3.1,2,8.3,1.4,10.9-2.6c2.5-4,2.1-8.8-1.1-10.8 C637.3,50.9,633.2,53.6,630.7,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M638.9,57.3c0,0-3.2-0.5-5.4,3.6c0,0,2-0.5,4.5,0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M614.4,49.2c0,1.5-0.8,2.7-1.8,2.7c-1,0-1.8-1.2-1.8-2.7c0-1.5,0.8-2.7,1.8-2.7 C613.6,46.5,614.4,47.7,614.4,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M613.3,66.4c0,0-2.6,5.1-9.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M606.9,50.3l-3.3,9.6c-0.3,1,0,2.1,0.9,2.6l2.7,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M617.2,44.7c0,0-3.7-2.6-7.3-1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 597.9,
    cy: 49.2,
    rx: 1.8,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M594.5,44.6c0,0,2.6-2.5,6.1-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M611.6,59.2c0.5,1.4,3.1,1.8,5.8,0.8c2.8-0.9,4.6-2.8,4.2-4.2c-0.5-1.4-3.1-1.8-5.8-0.8 C613,56,611.1,57.8,611.6,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M594.9,55v5.4c2.3,0.3,4.1-0.4,4.4-1.5C599.7,57.4,597.7,55.7,594.9,55z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "518.8,496.2 520,473.4 473.8,473.4 473.1,496.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "473.4,486.7 520,473.4 473.8,473.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "590.9,497.7 587.2,474.8 542.1,474.8 547.8,497.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "611.4,109.1 619.7,109.1 620.5,110.7 616.6,113.6 613.3,113.6 610.6,110.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "544.8,485.8 587.2,474.8 542.1,474.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "641.5,95.3 615.2,105 620,116 642.7,97.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "604.7,98 603.4,100.6 610.3,115 615.2,105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "613.3,113.6 600.9,210.3 610.6,222.8 623.2,211.4 616.6,113.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 668.5,
    y1: 161.2,
    x2: 682.3,
    y2: 218.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 571.2,
    y1: 195.9,
    x2: 570.1,
    y2: 161.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M590.9,497.7l4.1,16.7h-60.5l0,0c-2-8.5,4.5-16.7,13.3-16.7h0H590.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M518.8,496.2v18.2h-63.4l0.1-1.5c0.5-9.3,8.2-16.7,17.6-16.7h0H518.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M472.2,499.9c0,0-1.4-6-4.8-4.4c-3.4,1.6,4.6,4.6,4.6,4.6l-4.7,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M472.2,499.9c0,0,1.4-6,4.8-4.4c3.4,1.6-4.6,4.6-4.6,4.6l4.7,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M548.2,502c0,0-1.4-6-4.8-4.4c-3.4,1.6,4.6,4.6,4.6,4.6l-4.7,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M548.2,502c0,0,1.4-6,4.8-4.4s-4.6,4.6-4.6,4.6l4.7,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M600.9,100.1c0,0-2.5,25.9-6.5,64.9c-4,39.1-4.2,103.8-42.4,106.6c0,0-4.2-7.3-17.7-4.8 c0,0,11.8-6.1,20.8-20.1c9-14,13.4-132.1,13.4-132.1L600.9,100.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "598.8,121.9 595.7,152.4 605.4,144.1 604.7,122.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M650.6,98.5c0,0-9.7,41.9-14.5,80.7c-4.8,38.8-3.1,76.4-15.4,99.2c0,0,49.1,8.8,49,28.6 c0,0,13.8-15.3,14-36.2c0.1-20.9,8.2-159,8.2-159L650.6,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M691.9,236.3c-0.4,2.8,9.4,36.9-19.3,47.1s-69.8,32.5-42.3,64l46.1-16.7l50-47.3l-9.7-43L691.9,236.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M680.7,279.2c0,0,33.3-15.5,30.9-43.8c-2.1-25-19.8-30.1-19.8-30.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M532.7,214.7c-0.2,2,10.5,7,19.1,8.1c7.3,0.9,24.3,1.2,29.3,1.3l4.4-28.9c-2.8-0.8-8.5-3-11.2-3.7 c-7.3-1.6-22.4-2.3-23.3,0.3c-0.8,2.6,11.7,5.8,10.5,6.6c-1.2,0.8-11.8,1.3-15.8-0.3c-4-1.5-12-6.1-14.1-4.8 c-2.1,1.4-1,4.8-1,4.8s-2.9-2.1-3.9-0.1c-1,2,2.6,6.4,2.6,6.4s-1.4-1.4-2,1.2c-0.5,2.5,7.1,7.2,7.1,7.2S532.9,212.8,532.7,214.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M678.7,244.4L678.7,244.4c13,0.7,24.2-9.3,24.9-22.3l4.7-86.3c0.7-13-9.3-24.2-22.3-24.9l0,0 c-13-0.7-24.2,9.3-24.9,22.3l-4.7,86.3C655.7,232.5,665.7,243.7,678.7,244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M703.7,223.9c-1.2,12.5-11.3,21.9-22.4,20.8l-104.9-17l7-44.9l99.7,12.8 C694.2,196.7,704.9,211.4,703.7,223.9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "635,189.4 657.8,192.4 660,152.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "197.4,480.9 245.1,500.6 197.4,492.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 318.7,
    className: "st0",
    width: 13.2,
    height: 173.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.7,
    y: 480.9,
    className: "st0",
    width: 65.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84,514.4L84,514.4c2.4,0,4.4-2,4.4-4.4v-4.9c0-2.4-2-4.4-4.4-4.4h0c-2.4,0-4.4,2-4.4,4.4v4.9 C79.6,512.4,81.5,514.4,84,514.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.1,514.4L245.1,514.4c2.4,0,4.4-2,4.4-4.4v-4.9c0-2.4-2-4.4-4.4-4.4l0,0c-2.4,0-4.4,2-4.4,4.4v4.9 C240.7,512.4,242.7,514.4,245.1,514.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "131.7,480.9 84,500.6 131.7,492.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.3,169.5c0,0-117.5-5.7-122,78.4s78.5,125.3,150.9,98C304.8,308.1,297.5,188.5,175.3,169.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "308.9,488.9 342.4,489.3 335.5,439 296.4,452.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "307.7,514.7 323.5,514.6 324.5,504.4 333.2,514.5 370.4,514.4 342.4,489.3 308.9,488.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M271.4,278.4c-17.7,6.4-26.9,25.9-20.5,43.6l44.5,151.4l52.7-9.2l-31.2-155.6l0,0c-0.2-3.2-0.8-6.4-1.9-9.5 C308.6,281.3,289.1,272.1,271.4,278.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M103.9,100.8c0,0-14.5-18.5,7.1-27.4c10.9-4.5,14-10.4,10.9-18.6c-3-8.2,0.4-17.2,9-21.9 s12.3-18.9,30.4-10.6c0,0,22.7,8.9,21.8,22.8s-0.7,12.7,4.1,22.1c4.8,9.4-5.3,20.7-5.6,26.4c-0.4,5.5,2.1,7.3,2.1,7.3H103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M276,196.4L276,196.4c-7.5,9-21,10.3-30,2.9l-68-56.1c-9-7.5-10.3-21-2.9-30l0,0c7.5-9,21-10.3,30-2.9 l68,56.1C282.2,173.8,283.5,187.3,276,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M103.7,252.4c0,0-6.2,7.1-8.7,12.8c-2.5,5.8,27,2.6,27,2.6l-3.2-27.7L103.7,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.8,318.2l-1.4,4.5c-5.5,17.7-24.4,27.6-42.1,22.2l-109.6-33.9c-17.7-5.5-27.6-24.4-22.2-42.1l1.4-4.5 c5.5-17.7,24.4-27.6,42.1-22.2l109.6,33.9C306.3,281.6,316.2,300.5,310.8,318.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M291.2,339.9L291.2,339.9c-6.8,18.6-27.5,28.3-46.1,21.5l-129.8-47.2c-18.6-6.8-28.3-27.5-21.5-46.1l0,0 c6.8-18.6,27.5-28.3,46.1-21.5l129.8,47.2C288.3,300.6,298,321.3,291.2,339.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M134.2,102.6l-37.3,17.6c0,0,8.3,95.4,9.2,105.9c0.9,10.5-2.4,26.4-2.4,26.4s26.2,4.1,61.1,3.2 c25.7-0.7,28.9-8.9,28.9-8.9S192,201,198,186.6c4.1-9.7,6.9-15.7,4.5-26.8c-2.4-11.1-9.8-34.7-7-54l-23.4-2.4L134.2,102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M172.1,60.1v43.4c0,0,0,0.5-0.1,1.4c-0.4,3.5-2.7,12.6-14.5,12.5c-10.8-0.1-18.3-8-21.5-12.2 c-1.2-1.5-1.8-2.5-1.8-2.5l5.4-42.6H172.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "172.1,103.4 152.8,78.8 172.1,75.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M173,86.4c-7.7,2.5-18.3-0.5-25.9-8.5c-7.5-7.9-24.5-37.5-1.9-51.3c22.6-13.8,36,9,36.6,12.6 c0,0,0.2,12.5,0.4,21.2c0.1,2.2,0.1,4.2,0.1,5.7c0,0.2,0,0.5,0,0.7C182.4,73.7,180.6,83.9,173,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161.2,22.2c0,0,20.6,0.7,23.2,20.4L174,43.1c0,0,0.2-6.8-5.1-9.7c0,0,3.7,5.2,2.4,10.2l-12.1,1.2 c0,0-0.5-7.3,0.1-10.3c0,0-2.9,6.7-3,10.7l-8.5,2.3c0,0,0.1,6.9-3,9.3c-3.1,2.5-7.2,13.5-7.2,13.5s-8.8-24.3-4.9-32 C136.6,30.7,143.6,18.3,161.2,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M143.5,62.7c1.3,4.1,1.3,6.7-1.9,7.7c-3.2,1-7.6-0.7-8.9-4.7c-1.3-4.1,0.2-8.2,3.3-9.2 C139.2,55.4,142.1,58.7,143.5,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M135.4,60.6c0,0,5.1-0.2,5.5,4.1c0,0-1.7-1.5-4.2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M162.3,56.9c0,1.6,0.8,3,1.9,3c1.1,0,1.9-1.3,1.9-3c0-1.6-0.8-3-1.9-3C163.2,53.9,162.3,55.2,162.3,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M176.4,55.7c0,1.6,0.8,3,1.9,3c1.1,0,1.9-1.3,1.9-3c0-1.6-0.8-3-1.9-3C177.3,52.7,176.4,54,176.4,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M167.5,76c1.9,0.7,4.1-0.4,4.7-2.3l-7-2.4C164.6,73.2,165.6,75.4,167.5,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M158.6,53.6c0,0,3.3-4.1,7.2-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M176.7,50.3c0,0,2.4-0.4,5,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M171.4,55.9c0,0,0.1,8.2,4.9,9.2c0,0-1.5,1.4-3.4,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.9,65.9c-0.4,1.6-3.1,2.2-6,1.5s-4.9-2.6-4.5-4.2c0.4-1.6,3.1-2.2,6-1.5 C163.3,62.4,165.3,64.3,164.9,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M182.3,66.1c-1.7,0.1-3.2-0.5-3.5-1.5c-0.5-1.4,1-3.1,3.4-4.2C182.2,62.6,182.2,64.6,182.3,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.1,230.6c0.4,2.9-9.9,38.7,20.3,49.5c30.2,10.8,73.4,34.2,44.5,67.3l-48.4-17.5L67,280.1l10.2-45.2 L103.1,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M114.8,275.7c0,0-35-16.3-32.5-46.1c2.2-26.3,20.8-31.6,20.8-31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M242.2,197.3c-8.2-8.6-8.4-21.3-0.4-28.2l77.3-51.3c2.2-2.2,4.6-4.9,6.3-7.3c4-5.7,16.7-19.8,18.8-18.1 c2.1,1.7-4.5,13.1-3,13.1c1.5,0,8.4-7.2,11.1-10.6c2.7-3.3,7.3-11.3,9.8-11.3c2.6,0,3.5,3.5,3.5,3.5s1.4-3.2,3.3-2.1 c2,1.2,1.1,6.7,1.1,6.7s0.6-1.9,2.4-0.1c1.8,1.8-2.4,9.7-2.4,9.7s1.4-1.2,2.6,0.4c1.2,1.6-5.5,11.3-12.5,16.6 c-6.2,4.8-22.3,14.5-25.7,16.6l-62.7,65.1C263.7,207.2,250.4,205.9,242.2,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M142.5,71.8c0,1.7-1.4,3.1-3.2,3.1c-1.7,0-3.1-1.4-3.1-3.2c0-1.7,1.4-3.1,3.2-3.1 C141.1,68.7,142.5,70.1,142.5,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M197.7,187.4c0,0,6.7-14.1,5.6-21.5c-1.1-7.3-7.1-27.2-7.9-33.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "198.6,488.9 232,489.3 239.2,466.6 202.6,463.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "197.4,514.6 213.2,514.6 214.2,504.4 222.9,514.5 260.1,514.3 232,489.3 198.6,488.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M266.1,292.8c-18.5-3.3-36.2,9.1-39.4,27.6L195,469.2l52.6,10.1l43.1-137.9l0,0c1.4-2.8,2.5-5.9,3-9.2 C297,313.7,284.6,296.1,266.1,292.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M164.7,232.1L164.7,232.1c-10,6.1-23.2,2.9-29.3-7.1l-45.8-75.3c-6.1-10-2.9-23.2,7.1-29.3h0 c10-6.1,23.2-2.9,29.3,7.1l45.8,75.3C177.9,212.8,174.7,226,164.7,232.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 152.2,
    y1: 170.7,
    x2: 136.9,
    y2: 145.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M130.7,211.6c1.2-13,11.5-22.7,23-21.6l97,9c3.4,0,10.4,3.5,13.9,6.3c5.9,4.8,10.6,4.2,10.6,7.1 c0.1,3,0.6,6.8,1.7,8c1.1,1.2,5.8,0.8,4.6,1.8c-3.8,3.4-8,6.6-16.8,3.1c-8.6-3.4-12.9-5.2-17-6.3L149.4,237 C137.9,236,129.6,224.5,130.7,211.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.9,172.2c0,0,3.3-6.6-11.1-15.9l-42.5,42.5L360.9,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M254.8,211.8l60.1-56.1c0,0,22.7,19.9,46,16.6l-76.1,49.4C284.8,221.6,263.5,222.7,254.8,211.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M265.7,220.8c0,0,8.3-6.4,14.1-11.8c1.4-1.3,3.7-0.4,2,1.9c-2,2.7-7.6,9.2-7.6,9.2s4.7-4,6.7-5.9 c2.3-2.2,3.7-0.7,2.2,1.2c-1.8,2.3-4.5,5.8-4.5,5.8s4.4-4.2,5.6-3.4c1.2,0.8-2.7,4.3-2.7,4.3l-11.1,3.2L265.7,220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M263,219.3c0,0,5.1-4.2,9.2-8.8c1.6-1.8,2.9-2.8,4-1.9c0.6,0.5-0.4,2-1.6,3.8c-3.2,4.4-7.7,8.4-7.7,8.4 L263,219.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 353.9,
    y: 236.2,
    className: "st8",
    width: 15.4,
    height: 278
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.7,
    y: 227,
    className: "st0",
    width: 498.1,
    height: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M379.3,250h-35.4c-1.6,0-3-1.3-3-3v-6.8h41.3v6.8C382.3,248.6,380.9,250,379.3,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M388.4,514.4h-53.6v-4.9c0-1.1,0.9-1.9,1.9-1.9h49.7c1.1,0,1.9,0.9,1.9,1.9V514.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M379.4,507.5h-35.5v-4.9c0-1.1,0.9-1.9,1.9-1.9h31.6c1.1,0,1.9,0.9,1.9,1.9V507.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M750.1,538.2H39.6c-6.6,0-11.9-5.3-11.9-11.9l0,0c0-6.6,5.3-11.9,11.9-11.9h710.4c6.6,0,11.9,5.3,11.9,11.9 l0,0C762,532.9,756.7,538.2,750.1,538.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSearch);
export default __webpack_public_path__ + "static/media/jobSearch.58f375848d68b299f2614c3572171a58.svg";
export { ForwardRef as ReactComponent };